import { useAuth } from "../context/AuthContext";
import React, { Fragment, useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { PaginationControl } from "react-bootstrap-pagination-control";
import { AxisDateTimeFull } from "../util/AxisDateTime";
import { UserLink, ShiftLink } from "../util/Links";
import AxisSpinner from "../components/AxisSpinner";
import { Container, Row, Col, Button } from "react-bootstrap";
import UserNoteCreateUpdateModal from "../modals/UserNoteCreateUpdateModal";

export const UserNotes = ({ user }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [offset, setOffset] = useState(0);
  const [totalShifts, setTotalShifts] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [fetchCount, setFetchCount] = useState(25);
  const [showNewNote, setShowNewNote] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    paginateNotes();
  }, [offset, user]);

  const paginateNotes = async () => {
    try {
      setLoading(true);

      var params = {
        user_id: user?.id,
      };

      const pageSettings = {
        direction: "dsc",
        key: "created",
        page: offset,
        elementPerPage: fetchCount,
      };
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const page = await authAxios().post(
        "/api/backoffice/users/user_notes_paging",
        pageSettings,
        config,
      );
      setLoading(false);
      if (page.data.content.length === 0) {
        if (dataSource.length === 0) {
          setTotalShifts(0);
        }
        setDataSource([]);
        return;
      }

      setDataSource(page.data.content);
      setTotalShifts(page.data.totalElements);
      var length = Math.ceil(page.data.totalElements / fetchCount);
      setTotalPages(length);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
    }
  };

  const SpinnerOrData = (loading) => {
    if (loading) return <AxisSpinner loading={loading} />;

    return (
      <Fragment>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Type</th>
              <th>Note</th>
              <th>Related Shift</th>
              <th>Author</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {dataSource.map((note) => (
              <tr
                key={note?.id}
                onClick={() => {
                  setSelected(note);
                  setShowNewNote(true);
                }}
              >
                <td>{note?.type}</td>
                <td>{note?.note}</td>
                <td>{ShiftLink(note?.shift)}</td>
                <td>{UserLink(note?.author)}</td>
                <td>{AxisDateTimeFull(note?.created)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div>
          <p>
            Page {offset + 1} of {totalPages}, showing {dataSource.length}
            record{dataSource.length === 1 ? "" : "s"} out of {totalShifts}
          </p>
          <div>
            <PaginationControl
              page={offset + 1}
              between={3}
              total={totalShifts}
              limit={fetchCount}
              changePage={(page) => {
                setOffset(page - 1);
              }}
              ellipsis={1}
            />
          </div>
        </div>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Row className={"icon-text-wrapper"}>
        <Col>
          <Container>
            <Row xs={"auto"} className={"justify-content-end"}>
              <Button variant="offblack" onClick={() => setShowNewNote(true)}>
                + New Note
              </Button>
            </Row>
          </Container>
        </Col>
      </Row>
      <br />
      {SpinnerOrData(loading)}

      <UserNoteCreateUpdateModal
        visible={showNewNote}
        close={() => {
          setSelected(null);
          setShowNewNote(false);
          paginateNotes();
        }}
        user={user}
        note={selected}
      />
    </Fragment>
  );
};
